export const home = {
    uk: {
        one_header: "ШУКАЄТЕ ЕФЕКТИВНИЙ СПОСІБ ВИВЧЕННЯ АНГЛІЙСЬКОЇ?",
        one_subheader: "Пропонуємо ефективну та зручну платформу для індивідуального вивчення мови",
        one_signup: "РЕЄСТРАЦІЯ",
        one_login: "УВІЙТИ",
        one_logout: "ВИЙТИ",
        two_heading_cap1: "Для учня",
        two_body_text1: "Інструмент підтримує вивчення англійської мови як під час онлайн-занять із викладачем, так і в форматі самостійного навчання у власному темпі.",
        two_heading_cap2: "Для репетитора",
        two_body_text2: "Застосунок містить готові завдання, тексти, діалоги та різноманітні навчальні матеріали.",
        two_who_we_are: "Про курс",
        two_heading_who: "Репетитори та студенти отримують потужний інструмент для ефективного вивчення англійської мови",
        two_body_text_who1: "Курс складається з 30 послідовних занять і створений для тих, хто хоче нарешті почати розуміти та використовувати англійську в реальному житті.",
        two_body_text_who2: "Кожен урок охоплює п’ять ключових аспектів вивчення мови: граматику, словниковий запас, читання, аудіювання та говоріння. Курс включає 30 граматичних тем, 1 050 найуживаніших англійських слів, 30 текстів для читання, побудованих на цій лексиці, а також аудіювання й говоріння на 30 найпрактичніших тем із повсякденного життя.",
        two_find_out: "Дізнатися більше..."
    },
    en: {
        one_header: "ARE YOU LOOKING FOR AN EFFECTIVE WAY TO LEARN ENGLISH?",
        one_subheader: "We offer an efficient and user-friendly platform designed to support individual language learning",
        one_signup: "SIGN UP",
        one_login: "LOG IN",
        one_logout: "LOG OUT",
        two_heading_cap1: "For students",
        two_body_text1: "Tool supports English learning through online sessions with a tutor or via self-study at their own pace",
        two_heading_cap2: "For tutors",
        two_body_text2: "Application is featuring ready-made assignments, texts, dialogues, and various other resources",
        two_who_we_are: "Who we are",
        two_heading_who: "We provide tutors and students with a powerful tool designed to facilitate effective English language learning.",
        two_body_text_who1: "The program is a structured system of 30 sequential lessons, designed for those who want to finally start understanding and using English in real-life situations.",
        two_body_text_who2: "Each lesson covers five key aspects of language learning: grammar, vocabulary, reading, listening, and speaking. The course includes 30 grammar topics, 1,050 of the most commonly used English words, 30 reading texts built around this vocabulary, as well as listening and speaking practice across 30 of the most practical everyday topics.",
        two_find_out: "Find Out More..."
    },

}